module.exports = __webpack_public_path__ + "img/codensa.63f3b1e5.jpg";